import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
// scope names here based on the API namespace, using the values in file namespaces.ts for the left side of the colon, and the right side can be any name that make sense for the action queue item
export let EActionQueueItemType;
(function (EActionQueueItemType) {
  EActionQueueItemType["AppointmentRequested"] = "appointments:requested";
  EActionQueueItemType["BroadcastRequest"] = "broadcasts:request";
  EActionQueueItemType["CustomActionInvoke"] = "followups:invoke";
  EActionQueueItemType["CustomActionManual"] = "followups:manual";
  EActionQueueItemType["DncPatientInitiatedText"] = "messages:dnc-patient-initiated-text";
  EActionQueueItemType["FeedbackReceived"] = "feedbackResponses:received";
  EActionQueueItemType["LumabotFlowCompleted"] = "lumabotFlows:completed";
  EActionQueueItemType["OfferAccepted"] = "offers:accepted";
  EActionQueueItemType["OfferInProgress"] = "offers:in-progress";
  EActionQueueItemType["PatientFormIntakeFormsCompleted"] = "patientForms:intake-form-completed";
  EActionQueueItemType["PatientFormIntakeFormsWrongContactNumber"] = "patientForms:wrong-contact-number";
  EActionQueueItemType["PatientFormPreQualificationFormCompleted"] = "patientForms:pre-qualification-form-completed";
  EActionQueueItemType["ReferralCalled"] = "referrals:called";
  EActionQueueItemType["ReferralReceived"] = "referrals:received";
})(EActionQueueItemType || (EActionQueueItemType = {}));
export let EActionQueueItemStatus;

// ref to https://github.com/lumahealthhq/types-model-repository/pull/18
(function (EActionQueueItemStatus) {
  EActionQueueItemStatus["Accepted"] = "accepted";
  EActionQueueItemStatus["Canceled"] = "canceled";
  EActionQueueItemStatus["Expired"] = "expired";
  EActionQueueItemStatus["Invoked"] = "invoked";
  EActionQueueItemStatus["Pending"] = "pending";
  EActionQueueItemStatus["Rejected"] = "rejected";
})(EActionQueueItemStatus || (EActionQueueItemStatus = {}));
export const fieldsActionQueueItem = _extends({}, fieldsIBaseModel, {
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  context: {
    type: 'Object'
  },
  dismissedBy: {
    type: 'ID',
    ref: EModel.User
  },
  expireAt: {
    type: 'Date'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  label: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  refId: {
    type: 'Text'
  },
  status: {
    type: 'Option',
    values: EActionQueueItemStatus
  },
  type: {
    type: 'Option',
    values: EActionQueueItemType
  }
});